import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;

function load() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(`${API}/launch-timer`)
      .then((r) => r.json())
      .then((d) => {
        cache = { ...d, skew: new Date(d.server_now).getTime() - Date.now() };
        return cache;
      })
      .catch(() => {
        cache = { enabled: false, launch_at: null, skew: 0 };
        return cache;
      });
  }
  return inflight;
}

export function splitRemaining(ms) {
  const t = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(t / 86400),
    hours: Math.floor((t % 86400) / 3600),
    minutes: Math.floor((t % 3600) / 60),
    seconds: t % 60,
    total: t,
  };
}

export function useLaunchTimer() {
  const [cfg, setCfg] = useState(cache);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let alive = true;
    load().then((c) => alive && setCfg(c));
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const launchMs = cfg?.launch_at ? new Date(cfg.launch_at).getTime() : null;
  const remainingMs = launchMs != null ? launchMs - (now + (cfg?.skew || 0)) : 0;
  const enabled = Boolean(cfg?.enabled && launchMs);

  return {
    loading: !cfg,
    enabled,
    headline: cfg?.headline || 'Sale opens in',
    launchAt: launchMs ? new Date(launchMs) : null,
    counting: enabled && remainingMs > 0,
    launched: enabled && remainingMs <= 0,
    remaining: splitRemaining(remainingMs),
  };
}
